'use client';

import type { FC } from 'react';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import ProductRating from '@hyex/modules/shared/Product/common/ProductRating';

type Props = {
  feedback: string;
  author: string;
  rating: number;
  image?: string | ImageProps['src'];
};

const ProductReview: FC<Props> = ({ feedback, author, rating, image }) => {
  return (
    <div className="embla-slide">
      <div className="reviews-item">
        {/* <Stars /> */}
        <p>
          <i>{feedback}</i>
        </p>

        <div className="customer">
          {image && (
            <span className="photo-wrapper">
              <Image alt="customer photo" src={image} width={160} height={160} quality="70" />)
            </span>
          )}
          {rating && <ProductRating rating={rating} />}
          <b>{author}</b>
        </div>
      </div>
    </div>
  );
};

export default ProductReview;
